// extracted by mini-css-extract-plugin
module.exports = {"container":"Authenticated_container__2S8RS","wrapper":"Authenticated_wrapper__1o5Gr","formButton":"Authenticated_formButton__3ZVrX"};